const FormitiTrustBlock = () => (
  <div className="border-t border-background/10 bg-background/5 py-6">
    <p className="text-sm leading-relaxed opacity-80 max-w-4xl">
      <strong className="font-semibold opacity-100">
        Privacy360 is the technology arm of Formiti Data International
      </strong>
      , a global outsourced Data Protection Officer service operating across 120+
      jurisdictions. Formiti's DPO clients include Baylor College of Medicine, NTT Data
      Centers, WilsonHR, and Palexy.{" "}
      <a
        href="https://formiti.com"
        rel="noopener"
        target="_blank"
        className="underline underline-offset-2 hover:opacity-100"
      >
        Learn about Formiti →
      </a>
    </p>
  </div>
);

export default FormitiTrustBlock;
